export default "__VITE_ASSET__DNIhaSmV__"